<script lang="ts">
  // components
  import moneyFormatters from "@shared/filters/money.js";

  // stores
  import { creditsStore } from "@retailer/stores/CreditsStore";

  $: showSection = $creditsStore.loaded.available && $creditsStore.available.length > 0;

</script>

{#if showSection}
  <div class="fizz-inset-squish-32">
    <div class="fizz-bordered">
      <h4 class="fizz-heading-4 fizz-inset-squish-24">Available Credits</h4>
    </div>
    <div
      class="fizz-flex-row fizz-flex-wrap fizz-full-width fizz-border-bottom fizz-border-left fizz-border-right"
    >
      {#each $creditsStore.available as creditInfo}
        <div class="fizz-inset-squish-24">
          <p class="fizz-text-eyebrow">{creditInfo.distributor_name}</p>
          <p class="fizz-text-large">{moneyFormatters.filter5()(creditInfo.amount)}</p>
        </div>
      {/each}
    </div>
  </div>
{/if}
